<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">

        <v-template v-for="(item, index) of $store.state.settings.settings" :key="item.id">
          <v-text-field :label="item.description" v-model="$store.state.settings.settings[index].value"
            :rules="requiredRule" required>
          </v-text-field>
        </v-template>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import { busEvent } from '../../main';

export default {
  name: 'SettingsForm',
  data() {
    return {
      valid: true,
      requiredRule: [(v) => !!v || 'Campul trebuie completat.'],
    };
  },

  created() {
    this.getSettings();
  },

  methods: {
    ...mapActions('settings', ['getSettings', 'updateSettings']),

    async submit() {
      if (this.$refs.form.validate() && this.valid) {
        await this.updateSettings();
        busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
      }
    },
  },
};
</script>

<style>

</style>
